import type { ReactNode } from 'react';

interface Props {
  /** The primary control row (search, quick chips, Add filter, sort). */
  children: ReactNode;
  /** Optional active-filter summary row (see ActiveFilters) — rendered below a divider. */
  active?: ReactNode;
  className?: string;
}

/**
 * The shared toolbar shell: the primary control row plus an optional
 * active-filter row. Deliberately chromeless — a quiet wrap-row of compact
 * controls rather than a bordered/shadowed card, so filters read as page
 * chrome instead of content. Replaces the hand-rolled toolbar containers
 * that had drifted across the modules.
 */
export default function FilterBar({ children, active, className = '' }: Props) {
  return (
    <div className={className}>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
      {active}
    </div>
  );
}
